// extracted by mini-css-extract-plugin
export default {"leftBoder":"style_leftBoder__h9zPQ","dangerBorder":"style_dangerBorder__fcO+m"};